import { Head } from 'head/Head';

const ProfileMetadataRoute = () => (
  <Head
    title="Profile"
    description="Manage your Tock profile and reservations across all experiences on Tock."
    keywords="tock profile, tock reservations, view tock reservations, bookings, tickets, prix fixe, profile, payments, credit card, transactions"
  />
);
export default ProfileMetadataRoute;
